import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { DEFAULT_NOTICES } from "../notice/circular_constant.js";
// const DEFAULT_NOTICES = [
//   { name: "Uniform and Dress Code Compliance", link: "../../assets/notice/dresscode_circular.pdf", date: "Nov", day: "24" },
//   { name: "Half Yearly Examination Form Circular", link: "../../assets/notice/exam_form_circular.pdf", date: "Nov", day: "10" },
//   { name: "Jac Exam Form Notification", link: "../../assets/notice/inter_exam_form_jac.jpeg", date: "Nov", day: "15" },
//   { name: "Intermediate Exam Form Fee 2026", link: "../../assets/notice/EXAM_FORM_FEE_INT_2026.pdf.pdf", date: "Nov", day: "18" },
// ];

export default function NoticeComponent({ notices = DEFAULT_NOTICES }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        // soft gradient + subtle pattern
        background:
          "linear-gradient(135deg, rgba(79,70,229,0.08) 0%, rgba(16,185,129,0.08) 100%)",
        border: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip
              size="small"
              label="Latest Circulars"
              sx={{
                fontWeight: 700,
                letterSpacing: 0.2,
                bgcolor: "primary.main",
                color: "primary.contrastText",
                "& .MuiChip-label": { px: 1 },
              }}
            />
          </Stack>
          <Link
            component={RouterLink}
            to="/circular"
            underline="none"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              fontSize: 12.5,
              color: "text.secondary",
              "&:hover": { color: "text.primary" },
            }}
            aria-label="View all circulars"
          >
            View all <ArrowOutwardIcon sx={{ fontSize: 16 }} />
          </Link>
        </Stack>

        <Divider sx={{ mb: 1 }} />

        <List
          disablePadding
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 0.5,
          }}
        >
          {notices.map((n, idx) => (
            <ListItem
              key={`${n.name}-${idx}`}
              disableGutters
              sx={{
                borderRadius: 1.5,
                px: 1,
                py: 0.75,
                transition: "background-color .2s ease, transform .2s ease",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="open"
                  component={RouterLink}
                  to={n.link || "#"}
                  size="small"
                >
                  <ChevronRightIcon fontSize="small" />
                </IconButton>
              }
            >
              <CardActionArea
                component={RouterLink}
                to={n.link || "#"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 1,
                  py: 0.25,
                }}
              >
                {/* date pill */}
                <Box
                  sx={{
                    width: 46,
                    minWidth: 46,
                    height: 46,
                    borderRadius: 1.5,
                    bgcolor: "common.white",
                    boxShadow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                  }}
                  aria-hidden
                >
                  <Typography sx={{ fontWeight: 800, fontSize: 14 }}>{n.day}</Typography>
                  <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{n.date}</Typography>
                </Box>

                {/* text */}
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontSize: { xs: 13, sm: 13.5 },
                        fontWeight: 600,
                        color: "text.primary",
                      }}
                    >
                      {n.name}
                    </Typography>
                  }
                  secondary={
                    n.meta ? (
                      <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
                        {n.meta}
                      </Typography>
                    ) : null
                  }
                  sx={{ ml: 0.5, mr: 4 }}
                />
              </CardActionArea>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}


// import React from "react";
// import { Box, Typography } from "@mui/material";
// import { Link } from "react-router-dom";

// export default function NoticeComponent() {
//   const notices = [
//     {
//       name: "SoEs Admission Form and Guideline",
//       link: "#",
//       date: "Jun 23",
//       day: "14",
//     },
//     {
//       name: "आई सी टी योजना के सफल क्रियान्यन एवं अनुश्रवण के सम्बन्ध में",
//       link: "#",
//       date: "Jun 23",
//       day: "14",
//     },
//     {
//       name: "Performance Appraisal 2021",
//       link: "#",
//       date: "Jun 23",
//       day: "14",
//     },
//     {
//       name: "राज्य के 80 आदर्श विद्यालयों में शिक्षकों की सेवा लेने हेतु शिक्षकों द्वारा आवेदन।",
//       link: "#",
//       date: "Jun 23",
//       day: "14",
//     },
//   ];

//   return (
//     <div className="w-full max-w-sm rounded-lg border bg-white shadow-sm p-4">
//       <h3 className="text-sm font-semibold mb-2 text-gray-800">Latest Circular</h3>
//       <ul className="space-y-2">
//         {notices.map((notice, idx) => (
//           <li key={idx} className="flex gap-2 items-start">
//             <div className="w-12 h-12 flex flex-col items-center justify-center text-xs bg-gray-200 rounded">
//               <span className="font-bold">{notice.day}</span>
//               <span>{notice.date}</span>
//             </div>
//             <a href={notice.link} className="text-xs text-blue-600 hover:underline">
//               {notice.name}
//             </a>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

